module.exports = __webpack_public_path__ + "static/batterie-bb9b72cfe3a5cb178c822a51cd2cc33d.png";